export const formatCurrency = (n: number, fixed: number = 2) => {
  return '$' + n.toFixed(fixed).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
export const formatPhoneNumber = (phoneNumber: string) => {
  var cleaned = ('' + phoneNumber).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumber;
};

export const camelCaseToPascalCase = (text?: string) => {
  if (!text) return;

  return text[0].toUpperCase() + text.slice(1);
};

export const replaceHyphenWithSpace = (name?: string) => {
  return name?.replace(/-/g, ' ') ?? '';
};

const convertNumberToDoubleDigits = (time: number): string => {
  return Math.floor(time / 10) ? time.toString() : `0${time}`;
};

export const formatTimeMinutes = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  return convertNumberToDoubleDigits(minutes);
};

export const formatTimeSeconds = (seconds: number) => {
  const currentSeconds = seconds % 60;
  return convertNumberToDoubleDigits(currentSeconds);
};

export const convertMinutesToMilliseconds = (minutes: number) => {
  return minutes * 60 * 1000;
};
